import { render, staticRenderFns } from "./ErrorContent.vue?vue&type=template&id=5ee0edf2"
import script from "./ErrorContent.vue?vue&type=script&lang=js"
export * from "./ErrorContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports